{
  "responseShape": "服务器响应与预期格式不符——请刷新。",
  "badRequest": "请求无效，请检查您的输入。",
  "forbidden": "您没有执行此操作的权限。",
  "facilityRequired": "请在页眉选择机构以使用此模块。",
  "notFound": "未找到资源。",
  "conflict": "资源已存在。",
  "validation": "验证错误。",
  "tooManyRequests": "请求过于频繁，请稍后再试。",
  "serverError": "服务器错误，请稍后再试。",
  "unexpected": "发生意外错误。",
  "network": "网络错误，请检查您的连接。",
  "requestSetup": "发生错误，请重试。",
  "sessionExpired": "您的会话已过期，请重新登录。"
}
